import React, { useState, useEffect, useRef } from 'react';
import { apiFetch } from './api';
import TaskPopup from './taskPopup';

const kuerzel = (name) => {
  if (!name) return '?';
  const woerter = name.trim().split(/\s+/);
  const erst = woerter[0].charAt(0).toUpperCase();
  const letzt = woerter.length > 1 ? woerter[woerter.length - 1].charAt(0).toUpperCase() : '';
  return erst + letzt;
};

const Masterkalender = ({ user }) => {
  const [ansicht, setAnsicht] = useState('2wochen');
  const [tasks, setTasks] = useState([]);
  const [deadlines, setDeadlines] = useState([]);
  const [alleUsers, setAlleUsers] = useState([]);
  const [alleProduktionen, setAlleProduktionen] = useState([]);
  const [alleFormate, setAlleFormate] = useState([]);
  const [alleBackoffice, setAlleBackoffice] = useState([]);
  const [alleProjekte, setAlleProjekte] = useState([]);
  const [filterUsers, setFilterUsers] = useState([]);
  const [filterMutter, setFilterMutter] = useState(null);
  const [filterProjekt, setFilterProjekt] = useState(null);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [aktiverTaskId, setAktiverTaskId] = useState(null);

  const [bereichOffen, setBereichOffen] = useState(false);
  const [projektOffen, setProjektOffen] = useState(false);
  const bereichRef = useRef(null);
  const projektRef = useRef(null);

  const getMontag = (offsetWochen) => {
    const heute = new Date();
    const tag = heute.getDay();
    const diffZuMontag = tag === 0 ? -6 : 1 - tag;
    const montag = new Date(heute);
    montag.setDate(heute.getDate() + diffZuMontag + offsetWochen * 7);
    montag.setHours(0, 0, 0, 0);
    return montag;
  };

  const pad = (n) => String(n).padStart(2, '0');
  const toDateStr = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  const anzahlWochen = ansicht === '2wochen' ? 2 : 4;
  const startMontag = getMontag(offset * anzahlWochen);
  const tage = Array.from({ length: anzahlWochen * 7 }, (_, i) => {
    const d = new Date(startMontag);
    d.setDate(startMontag.getDate() + i);
    return d;
  });

  const vonStr = toDateStr(tage[0]);
  const bisStr = toDateStr(tage[tage.length - 1]);

  const bereichGruppen = [
    { label: 'Produktionen', items: alleProduktionen.map(p => ({ ...p, typ: 'produktion' })) },
    { label: 'Formatentwicklung', items: alleFormate.map(f => ({ ...f, typ: 'format' })) },
    { label: 'Backoffice', items: alleBackoffice.map(b => ({ ...b, typ: 'backoffice' })) },
  ];

  const gefilterteProjekte = filterMutter
    ? alleProjekte.filter(p => p.parent_typ === filterMutter.typ && p.parent_id === filterMutter.id)
    : alleProjekte;

  const toggleUser = (id) => {
    setFilterUsers(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const handler = (e) => {
      if (bereichRef.current && !bereichRef.current.contains(e.target)) setBereichOffen(false);
      if (projektRef.current && !projektRef.current.contains(e.target)) setProjektOffen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    const ladeAlles = async () => {
      setLoading(true);
      const [usersRes, prodRes, formatRes, backRes, projekteRes] = await Promise.all([
        apiFetch('/users'),
        apiFetch('/produktionen'),
        apiFetch('/formate'),
        apiFetch('/backoffice'),
        apiFetch('/projekte'),
      ]);
      if (!usersRes || !prodRes || !formatRes || !backRes || !projekteRes) return;
      const users = await usersRes.json();
      const prod = await prodRes.json();
      const formate = await formatRes.json();
      const back = await backRes.json();
      const projekte = await projekteRes.json();
      setAlleUsers(users);
      setAlleProduktionen(prod);
      setAlleFormate(formate);
      setAlleBackoffice(back);
      setAlleProjekte(projekte);
      setLoading(false);
    };
    ladeAlles();
  }, []);

  useEffect(() => {
    const ladeTasks = async () => {
      let url = `/kalender/tasks?von=${vonStr}&bis=${bisStr}`;
      if (filterUsers.length === 1) url += `&user_id=${filterUsers[0]}`;
      if (filterMutter) url += `&mutter_typ=${filterMutter.typ}&mutter_id=${filterMutter.id}`;
      const res = await apiFetch(url);
      if (!res) return;
      const data = await res.json();
      let gefiltert = Array.isArray(data) ? data : [];
      if (filterUsers.length > 1) {
        gefiltert = gefiltert.filter(t => filterUsers.includes(String(t.user_id)));
      }
      if (filterProjekt) {
        gefiltert = gefiltert.filter(t => t.projekt_id === filterProjekt.id);
      }
      setTasks(gefiltert);
    };

    const ladeDeadlines = async () => {
      let url = `/kalender/deadlines?von=${vonStr}&bis=${bisStr}`;
      if (filterMutter) url += `&mutter_typ=${filterMutter.typ}&mutter_id=${filterMutter.id}`;
      const res = await apiFetch(url);
      if (!res) return;
      const data = await res.json();
      let gefiltert = Array.isArray(data) ? data : [];
      if (filterProjekt) {
        gefiltert = gefiltert.filter(dl => dl.id === filterProjekt.id);
      }
      setDeadlines(gefiltert);
    };

    ladeTasks();
    ladeDeadlines();
  }, [filterUsers, filterMutter, filterProjekt, offset, ansicht, alleProduktionen.length]);

  const istHeute = (d) => {
    const h = new Date();
    return d.getDate() === h.getDate() && d.getMonth() === h.getMonth() && d.getFullYear() === h.getFullYear();
  };

  const tagNamen = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  const formatDatum = (d) => `${d.getDate()}.${d.getMonth() + 1}.`;

  const tasksAnTag = (d) => {
    const ds = toDateStr(d);
    const gefiltert = tasks.filter(t => {
      if (!t.von || !t.bis) return false;
      return t.von <= ds && t.bis >= ds;
    });
    const gruppen = {};
    gefiltert.forEach(t => {
      if (!gruppen[t.id]) {
        gruppen[t.id] = { ...t, personen: [] };
      }
      gruppen[t.id].personen.push({ user_id: t.user_id, user_name: t.user_name });
    });
    return Object.values(gruppen);
  };

  const deadlinesAnTag = (d) => {
    const ds = toDateStr(d);
    return deadlines.filter(dl => dl.deadline === ds);
  };

  const textFarbe = (hex) => {
    if (!hex) return '#ffffff';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 140 ? '#1a1a1a' : '#ffffff';
  };

  const wochen = [];
  for (let w = 0; w < anzahlWochen; w++) {
    wochen.push(tage.slice(w * 7, w * 7 + 7));
  }

  return (
    <div style={{ padding: '40px' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 6px 0', letterSpacing: '-0.5px' }}>
            Masterkalender
          </h2>
          <p style={{ fontSize: '14px', color: '#9b9b9b', margin: 0 }}>
            {formatDatum(tage[0])} – {formatDatum(tage[tage.length - 1])} {new Date().getFullYear()}
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ display: 'flex', border: '1px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden' }}>
            {['2wochen', '4wochen'].map(a => (
              <button key={a} onClick={() => { setAnsicht(a); setOffset(0); }} style={{
                padding: '7px 16px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer',
                backgroundColor: ansicht === a ? '#1a1a1a' : '#ffffff',
                color: ansicht === a ? '#ffffff' : '#6b6b6b',
              }}>
                {a === '2wochen' ? '2 Wochen' : '4 Wochen'}
              </button>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <button onClick={() => setOffset(offset - 1)} style={navBtn}>←</button>
            <button onClick={() => setOffset(0)} style={{ ...navBtn, width: 'auto', padding: '0 12px', fontSize: '11px' }}>Heute</button>
            <button onClick={() => setOffset(offset + 1)} style={navBtn}>→</button>
          </div>
        </div>
      </div>

      {/* Filter-Leiste */}
      <div style={{
        backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px',
        padding: '16px 20px', marginBottom: '20px',
        display: 'flex', alignItems: 'flex-start', gap: '32px'
      }}>

        {/* Person */}
        <div style={{ flexShrink: 0 }}>
          <p style={filterLabel}>Person</p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
            <div onClick={() => setFilterUsers([])} style={{ ...chipStyle(filterUsers.length === 0), gridColumn: '1 / -1' }}>
              Alle
            </div>
            {alleUsers.map(u => (
              <div key={u.id} onClick={() => toggleUser(String(u.id))} style={chipStyle(filterUsers.includes(String(u.id)))}>
                <span style={{
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  width: '16px', height: '16px', borderRadius: '50%',
                  backgroundColor: filterUsers.includes(String(u.id)) ? 'rgba(255,255,255,0.25)' : '#d4d4d4',
                  fontSize: '8px', fontWeight: '700', marginRight: '5px', flexShrink: 0,
                  color: filterUsers.includes(String(u.id)) ? '#ffffff' : '#6b6b6b',
                }}>{kuerzel(u.name)}</span>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Trennlinie */}
        <div style={{ width: '1px', backgroundColor: '#efefef', alignSelf: 'stretch', flexShrink: 0 }} />

        {/* Bereich Dropdown */}
        <div ref={bereichRef} style={{ flexShrink: 0 }}>
          <p style={filterLabel}>Bereich</p>
          <div style={{ position: 'relative' }}>
            <div onClick={() => setBereichOffen(!bereichOffen)} style={dropdownTrigger(!!filterMutter)}>
              {filterMutter ? (
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {filterMutter.farbe && <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: filterMutter.farbe, flexShrink: 0 }} />}
                  {filterMutter.name}
                </span>
              ) : 'Alle Bereiche'}
              <span style={{ fontSize: '10px', color: '#c4c4c4', marginLeft: '8px' }}>▼</span>
            </div>

            {bereichOffen && (
              <div style={dropdownMenu}>
                <div onClick={() => { setFilterMutter(null); setFilterProjekt(null); setBereichOffen(false); }} style={dropdownItem(!filterMutter)}>
                  Alle Bereiche
                </div>
                {bereichGruppen.map(gruppe => gruppe.items.length > 0 && (
                  <div key={gruppe.label}>
                    <div style={{ padding: '6px 14px 3px', fontSize: '9px', fontWeight: '600', color: '#c4c4c4', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {gruppe.label}
                    </div>
                    {gruppe.items.map(m => (
                      <div key={`${m.typ}-${m.id}`}
                        onClick={() => { setFilterMutter(m); setFilterProjekt(null); setBereichOffen(false); }}
                        style={{
                          ...dropdownItem(filterMutter?.id === m.id && filterMutter?.typ === m.typ),
                          borderLeft: m.farbe ? `3px solid ${m.farbe}` : '3px solid transparent',
                        }}
                        onMouseEnter={(e) => { if (!(filterMutter?.id === m.id)) e.currentTarget.style.backgroundColor = '#fafafa'; }}
                        onMouseLeave={(e) => { if (!(filterMutter?.id === m.id)) e.currentTarget.style.backgroundColor = filterMutter?.id === m.id && filterMutter?.typ === m.typ ? '#f0f0ee' : 'transparent'; }}
                      >
                        {m.farbe && <span style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: m.farbe, flexShrink: 0 }} />}
                        {m.name}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Projekt Dropdown */}
        <div ref={projektRef} style={{ flexShrink: 0 }}>
          <p style={filterLabel}>Projekt</p>
          <div style={{ position: 'relative' }}>
            <div onClick={() => setProjektOffen(!projektOffen)} style={dropdownTrigger(!!filterProjekt)}>
              {filterProjekt ? filterProjekt.name : 'Alle Projekte'}
              <span style={{ fontSize: '10px', color: '#c4c4c4', marginLeft: '8px' }}>▼</span>
            </div>

            {projektOffen && (
              <div style={dropdownMenu}>
                <div onClick={() => { setFilterProjekt(null); setProjektOffen(false); }} style={dropdownItem(!filterProjekt)}>
                  Alle Projekte
                </div>
                {gefilterteProjekte.map(p => (
                  <div key={p.id}
                    onClick={() => { setFilterProjekt(p); setProjektOffen(false); }}
                    style={dropdownItem(filterProjekt?.id === p.id)}
                    onMouseEnter={(e) => { if (filterProjekt?.id !== p.id) e.currentTarget.style.backgroundColor = '#fafafa'; }}
                    onMouseLeave={(e) => { if (filterProjekt?.id !== p.id) e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    {p.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </div>

      {/* Kalender */}
      {loading ? (
        <p style={{ color: '#9b9b9b', fontSize: '14px' }}>Lädt...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {wochen.map((woche, wi) => (
            <div key={wi} style={{ backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '10px', overflow: 'hidden' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', borderBottom: '1px solid #efefef' }}>
                {woche.map((d, di) => (
                  <div key={di} style={{
                    padding: '8px 10px', borderLeft: di > 0 ? '1px solid #f4f4f4' : 'none',
                    backgroundColor: istHeute(d) ? '#f7f7f5' : 'transparent'
                  }}>
                    <div style={{ fontSize: '10px', color: '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {tagNamen[di]}
                    </div>
                    <div style={{
                      fontSize: '14px', fontWeight: '600', marginTop: '1px',
                      color: istHeute(d) ? '#1a1a1a' : '#6b6b6b',
                      display: 'inline-block',
                      ...(istHeute(d) ? { backgroundColor: '#f0f0ee', borderRadius: '10px', padding: '0 6px' } : {})
                    }}>
                      {formatDatum(d)}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', minHeight: '100px' }}>
                {woche.map((d, di) => {
                  const tagTasks = tasksAnTag(d);
                  const tagDeadlines = deadlinesAnTag(d);
                  return (
                    <div key={di} style={{
                      borderLeft: di > 0 ? '1px solid #f4f4f4' : 'none',
                      padding: '5px 4px', minHeight: '100px',
                      backgroundColor: istHeute(d) ? '#fafaf9' : 'transparent'
                    }}>
                      {tagDeadlines.map(dl => (
                        <div key={dl.id} style={{
                          fontSize: '9px', fontWeight: '600', padding: '2px 5px', marginBottom: '3px',
                          borderRadius: '4px',
                          backgroundColor: dl.mutter_farbe ? `${dl.mutter_farbe}22` : '#f0f0ee',
                          color: dl.mutter_farbe || '#6b6b6b',
                          border: `1px solid ${dl.mutter_farbe || '#e8e8e8'}`,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                        }}>
                          ⚑ {dl.name}
                        </div>
                      ))}

                      {tagTasks.map(t => {
                        const bg = t.mutter_farbe || '#1a1a1a';
                        const tc = textFarbe(bg);
                        return (
                          <div key={t.id}
                            onClick={() => setAktiverTaskId(t.id)}
                            style={{
                              marginBottom: '3px', borderRadius: '5px',
                              backgroundColor: bg, color: tc,
                              padding: '4px 6px', cursor: 'pointer', overflow: 'hidden'
                            }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '3px' }}>
                              <span style={{
                                fontSize: '10px', fontWeight: '600',
                                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1
                              }}>{t.name}</span>
                              <div style={{ display: 'flex', gap: '2px', flexShrink: 0 }}>
                                {t.personen.map(p => (
                                  <span key={p.user_id} style={{
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    width: '16px', height: '16px', borderRadius: '50%',
                                    backgroundColor: 'rgba(255,255,255,0.3)',
                                    fontSize: '7px', fontWeight: '700', color: tc,
                                    flexShrink: 0
                                  }}>{kuerzel(p.user_name)}</span>
                                ))}
                              </div>
                            </div>
                            <div style={{
                              fontSize: '9px', opacity: 0.8, marginTop: '1px',
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                            }}>{t.projekt_name}</div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Task Popup */}
      {aktiverTaskId && (
        <TaskPopup
          taskId={aktiverTaskId}
          onClose={() => setAktiverTaskId(null)}
        />
      )}

    </div>
  );
};

const navBtn = {
  width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #e8e8e8',
  backgroundColor: 'transparent', color: '#6b6b6b', cursor: 'pointer', fontSize: '14px'
};
const filterLabel = {
  fontSize: '10px', fontWeight: '600', color: '#9b9b9b',
  textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 8px 0'
};
const chipStyle = (aktiv) => ({
  display: 'flex', alignItems: 'center',
  padding: '5px 10px', borderRadius: '20px', cursor: 'pointer', fontSize: '12px',
  backgroundColor: aktiv ? '#1a1a1a' : '#f0f0ee',
  color: aktiv ? '#ffffff' : '#6b6b6b',
  fontWeight: aktiv ? '500' : '400',
  overflow: 'hidden',
});
const dropdownTrigger = (aktiv) => ({
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  padding: '6px 12px', border: `1px solid ${aktiv ? '#1a1a1a' : '#e8e8e8'}`,
  borderRadius: '8px', cursor: 'pointer', fontSize: '13px',
  backgroundColor: '#ffffff', color: aktiv ? '#1a1a1a' : '#9b9b9b',
  minWidth: '180px',
});
const dropdownMenu = {
  position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 300,
  backgroundColor: '#ffffff', border: '1px solid #e8e8e8', borderRadius: '10px',
  boxShadow: '0 8px 28px rgba(0,0,0,0.12)', minWidth: '220px', overflow: 'hidden'
};
const dropdownItem = (aktiv) => ({
  padding: '8px 14px', fontSize: '13px', cursor: 'pointer',
  backgroundColor: aktiv ? '#f0f0ee' : 'transparent',
  color: '#1a1a1a', display: 'flex', alignItems: 'center', gap: '8px',
});

export default Masterkalender;